module.exports = {
  CREDIT: 'credit',
  FIXED: 'fixed',
  PERCENTAGE: 'percentage',
};
